import { render, staticRenderFns } from "./QualityDetailsViewer.vue?vue&type=template&id=fb783c96&scoped=true"
import script from "./QualityDetailsViewer.vue?vue&type=script&lang=js"
export * from "./QualityDetailsViewer.vue?vue&type=script&lang=js"
import style0 from "./QualityDetailsViewer.vue?vue&type=style&index=0&id=fb783c96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb783c96",
  null
  
)

export default component.exports